import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import SuivreView from '../views/SuivreUnSignalementView.vue'
import SignalementDetailView from '../views/SignalementDetailView.vue'
import FaireUnSignalementView from '../views/FaireUnSignalementView.vue'
import ConfirmationView from '../views/ConfirmationView.vue'
import { withGeneralLayout } from '../services/pages.layout'

export interface RouteConfig {
  path: string
  name: string
  component: any // Component type from Vue
  meta?: {
    layout?: string
    [key: string]: any
  }
}

const routesConfig: RouteConfig[] = [
  { 
    path: '/', 
    name: 'home',
    component: withGeneralLayout(HomeView),
    meta: { layout: 'general' }
  },
  { 
    path: '/about', 
    name: 'about',
    component: withGeneralLayout(AboutView),
    meta: { layout: 'general' }
  },
  { 
    path: '/suivre-un-signalement', 
    name: 'suivre-un-signalement',
    component: withGeneralLayout(SuivreView),
    meta: { layout: 'general' }
  },
  { 
    path: '/signalement/:code?', 
    name: 'signalement-detail',
    component: withGeneralLayout(SignalementDetailView),
    meta: { layout: 'general' }
  },
  { 
    path: '/faire-un-signalement', 
    name: 'faire-un-signalement',
    component: withGeneralLayout(FaireUnSignalementView),
    meta: { layout: 'general' }
  },
  { 
    path: '/confirmation', 
    name: 'confirmation',
    component: withGeneralLayout(ConfirmationView),
    meta: { layout: 'general' }
  },
  // Routes commentées pour référence future
  // { path: '/contact', name: 'contact', component: withGeneralLayout(ContactView), meta: { layout: 'general' } },
]

export default routesConfig

